const PREMIUM_PACKAGE_ID = 'opening_hours';
const Wix = window.Wix;

export function removePublicJSONData(key, options) {
  return new Promise((resolve, reject) => {
    Wix.Data.Public.remove(key, options, resolve, reject);
  });
}

export function triggerSettingsUpdatedEvent(data) {
  return Wix.Settings.triggerSettingsUpdatedEvent(
    data,
    Wix.Utils.getOrigCompId()
  );
}

export function resizeComponent(options) {
  return new Promise((resolve, reject) => {
    Wix.Settings.resizeComponent(options, resolve, reject);
  });
}

export function openBillingPage() {
  Wix.Settings.openBillingPage();
}

export function getSitePages() {
  return new Promise(resolve => {
    Wix.getSitePages(sitePages => {
      resolve(sitePages);
    });
  });
}

export function getStyleParams() {
  return new Promise(resolve => {
    Wix.Styles.getStyleParams(styleParams => {
      resolve(styleParams);
    });
  });
}

export function openModal() {
  return new Promise(resolve => {
    Wix.openModal(
      `${window.location.protocol}//${window.location.hostname}${window.location.pathname}?app=Modal`,
      1000,
      350,
      resolve,
      Wix.Theme.DEFAULT
    );
  });
}

export function openSettingsModal(title) {
  return new Promise(resolve => {
    Wix.Settings.openModal(
      `${window.location.protocol}//${window.location.hostname}${window.location.pathname}?app=Modal`,
      1000,
      350,
      title,
      resolve
    );
  });
}

export function isPremium() {
  if (process.env.REACT_APP_PLAN) {
    return process.env.REACT_APP_PLAN === 'premium';
  }

  return Wix.Utils.getInstanceValue('vendorProductId') === PREMIUM_PACKAGE_ID;
}

export default Wix;



// WEBPACK FOOTER //
// ./src/commons/services/Wix.js